export default "__VITE_ASSET__d6183963__"